import React from "react"
import { animated, interpolate } from "react-spring"


const computeVisiblePercentage = (top, bottom, left, right, vw, vh) => {
  return interpolate([top, bottom, left, right], (top, bottom, left, right) => {
    if (bottom > vh || top > vh || left > vw || right > vw) {
      return 0
    }
    let out = 0
    if (left === 0) {
      // vertical scrolling
      if (top < 0) {
        // I'm exiting
        out = (vh - bottom) / vh
      } else {
        out = (vh - top) / vh
      }
    } else {
      // horizontal scrolling
      if (left < 0) {
        // I'm exiting
        out = (vw - right) / vw
      } else {
        out = (vw - left) / vw
      }
    }
    if (isNaN(out)) {
      return 0
    }
    return out
  })
}

const computeShadow = (top, bottom, left, right, vw, vh) => {
  return interpolate([top, bottom, left, right], (top, bottom, left, right) => {
    if (top > 0 && top < vh) {
      return 1 - (vh - top) / vh
    }
    if (left > 0 && left < vw) {
      return 1 - (vw - left) / vw
    }
    return 0
  })
}

const Animator = Component => ({ top, bottom, left, right, vh, vw, planarLeft, planarRight, planarTop, planarBottom, zIndex, ...props }) => {
  const openPercent = computeVisiblePercentage(
    planarTop,
    planarBottom,
    planarLeft,
    planarRight,
    vw,
    vh
  )

  return (
    <>
      <animated.div
        style={{
          position: "absolute",
          backgroundColor: "#000",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          opacity: computeShadow(
            planarTop,
            planarBottom,
            planarLeft,
            planarRight,
            vw,
            vh
          ),
          zIndex: zIndex + 1,
          pointerEvents: "none",
        }}
      ></animated.div>
      <animated.div
        className="page"
        style={{
          position: "absolute",
          top: bottom.interpolate(b => b >= vh ? -4 : -2),
          bottom: bottom.interpolate(b => b - 2),
          left: right.interpolate(r => r >= vw ? -4 : -2),
          right: right.interpolate(r => r - 2),
          zIndex,
          borderColor: "#005BBB",
          borderStyle: "solid",
          borderWidth: 2,
          borderRadius: 32,
        }}
      >
        <animated.div style={{
          position: "absolute",
          top: top,
          bottom: 0,
          left: left,
          right: 0
        }}>
          <Component {...props} openPercent={openPercent} />
        </animated.div>

      </animated.div>
    </>
  )
}

export default Animator
